import modal, { SDXModalDialogConfig } from 'lib/generic/SDXModalDialog';
import { hashDeepLink } from 'lib/util/url';

// Selector of SDX Lightbox triggers
const selector = '[target="sdxlightbox"]';

interface BrightcovePlayerElement extends HTMLElement {
	brightcoveapi : {
		pause() : void;
	}
}

/* SDX Lightbox has been closed */
function closedSdxLightbox() {

	// Remove deeplinking to this lightbox
	hashDeepLink.set('lightbox', undefined, '&');

	// Stop brightcove player
	modal.$contentHolder.find('.mod.modBrightcoveVideo').each((_, elem) => {
		(elem as BrightcovePlayerElement).brightcoveapi.pause();
	});
}

/* SDX Lightbox has been opened */
function openedSdxLightbox() {

	// Get url from passed config
	// Modal is a singleton class
	const url = modal.config?.url;

	if(!url) {
		return;
	}

	// Allow deeplinking to this lightbox (opens lightbox directly on page load)
	hashDeepLink.set('lightbox', `sel:${selector}[href="${url}"]`, '&');
}

/**
 * Global Handler for SDX Modal Dialogs
 * Triggered by A[target=sdxlightbox] tags
 * They must have a valid href url to load
 * We will use img tags for image urls
 * External urls will be loaded in iframe
 *
 * @author Marcel Greter (TAAGRMAL)
 */

function openSdxLightbox(event : JQuery.ClickEvent) {

	event.preventDefault();

	// Target should be an anchor tag with href
	const $anchor = jQuery(event.currentTarget);

	// Get target href from anchor tag
	let href = $anchor.attr('href');

	// Assertion for valid anchor href
	if (href === undefined || href === '') {
		throw Error(`${ selector } href needed`);
	}

	// Add the hash of the linked URL to the current page (for visibility control containers to work).
	const hashIndex = href.indexOf('#');
	if(hashIndex > -1) {
		window.location.hash = href.substring(hashIndex);
		hashDeepLink.update();
		href = href.substring(0, hashIndex);
	}

	// Init shared options from anchor data
	// tslint:disable:object-literal-sort-keys
	const options : SDXModalDialogConfig = {
		title: $anchor.data('sdxLightboxTitle'),
		width: $anchor.data('sdxLightboxWidth'),
		height: $anchor.data('sdxLightboxHeight'),
		class: $anchor.data('sdxLightboxClass'),
		url: href,
		on: {
			open: openedSdxLightbox,
			close: closedSdxLightbox,
			cancel: closedSdxLightbox,
		},
	};

	// Show the modal dialog
	modal.show(options);

}
// EO openSdxLightbox

// Use jQuery "live" to lazy handle all clicks on lighbox links
// More "initial load" efficient since testing is done on click
jQuery(document).on('click', `A[href]${ selector }`, openSdxLightbox);

/* Remove this once it is proven that we don't get any issues
 * with jQuery.on (it might be that some parent eats our events)
 * SCS.ensure(function(context) {
 * 	context.find('a[target="sdxlightbox"]:not([data-handler-attached])')
 * 		.on('click', openSdxLightbox).attr('data-handler-attached', 'true');
 * }, 'body, .ui-tabs-panel, .ui-dialog-content, .modTabNavigationContent');
 */



// WEBPACK FOOTER //
// typescript://../clientlibs/js/bootstrap/sdx-modal.ts